export const SET_IMAGES = "CART/SET_IMAGES";
